export const firebaseEnv = {
  key: process.env.REACT_APP_FIREBASE_KEY,
  auth: process.env.REACT_APP_FIREBASE_AUTH,
  dbUrl: process.env.REACT_APP_FIREBASE_DB_URL,
  project: process.env.REACT_APP_FIREBASE_PROJECT,
  storage: process.env.REACT_APP_FIREBASE_STORAGE,
  msgId: process.env.REACT_APP_FIREBASE_MSG_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measureId: process.env.REACT_APP_FIREBASE_MEASURE_ID
};

export const DEMO_USER_ID = process.env.REACT_APP_DEMO_USER_ID;
